import React, { Component } from 'react';
import Modal from 'react-modal';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import api from './api/index.js';

import './App.scss';

import PagePadding from './components/ui/PagePadding.js';
import Menu from './components/Menu.js';

import DateWrap from './DateWrap.js';
import CompanySpecific from './pages/CompanySpecific.js';
import FarmSpecific from './pages/FarmSpecific.js';
import FieldSpecific from './pages/FieldSpecific.js';
import TestPage from './pages/TestPage.js';
import Attendance from './pages/Attendance.js';
import Employees from './pages/Employees.js';
import TaskTestPage from './pages/TaskTest.js';
import ProcessorsPage from './pages/Processors.js';
import ProcessorReceiptsPage from './pages/ProcessorReceipts.js';
import ProcessorReceiptPage from './pages/ProcessorSingleReceipt.js';
import HarvestRecordPage from './pages/HarvestRecords.js';
import MapSelectTestPage from './pages/MapSelectTest.js';
import PayrollPage from './pages/Payroll.js';
import RequireLogin from './components/RequireLogin.js';
import LogoutPage from './pages/LogoutPage.js';


Modal.setAppElement('#root');

class App extends Component {
	constructor(props) {
		super(props);
		this.toastErrors = this.toastErrors.bind(this);
		this.toastSuccess = this.toastSuccess.bind(this);
	}
	
	componentDidMount() {
		api.errorFn = this.toastErrors;
		api.successFn = this.toastSuccess;
	}
	
	toastErrors(e) {
		if (typeof e === 'string')
			toast.error(e);
		else
			toast.error(e.message);
	}
	
	toastSuccess(msg) {
		toast.success(msg);
	}
	
	render() {
		console.log("Public URL", process.env.PUBLIC_URL);
		return (
			<div className={"App " + (api.isdev() ? 'dev' : 'prod') }>
			<RequireLogin>
				<Router basename={process.env.PUBLIC_URL}>
						<div className="route">
							<Menu />
							<PagePadding className="app-inner">
								<Switch className="page routes">
									<Route path="/" exact component={DateWrap(CompanySpecific)} />
									<Route path="/farm/:farm_id"  exact component={DateWrap(FarmSpecific)} />
									<Route path="/farm/:farm_id/field/:field_id" exact component={DateWrap(FieldSpecific)} />
									<Route path="/attendance" exact component={Attendance} />
									<Route path="/employees" exact component={Employees} />
									<Route path="/processors" exact component={DateWrap(ProcessorsPage)} />
									<Route path="/harvestrecords" exact component={DateWrap(HarvestRecordPage)} />
									<Route path="/processors/:processor_id/receipts" exact component={DateWrap(ProcessorReceiptsPage)} />
									<Route path="/processors/:processor_id/receipts/:receipt_id" exact component={DateWrap(ProcessorReceiptPage)} />
									<Route path="/tasktest" exact component={TaskTestPage} />
									<Route path="/test" exact component={TestPage} />
									<Route path="/test/mapselector" exact component={MapSelectTestPage} />
									<Route path="/payroll/:needleDate?"  component={PayrollPage} />
									<Route path="/logout"  component={LogoutPage} />
								</Switch>
							</PagePadding>
						</div>
					</Router>
				</RequireLogin>
				 <ToastContainer position={toast.POSITION.BOTTOM_CENTER}/>
			</div>
		);
	}
}

export default App;
